const Loader = (): JSX.Element => <p>Loading...</p>

export default Loader